const Card = ({ firstName, lastName, roleName, addressStreet, addressNumber, onEditClick, onDeleteClick, initials, avatar, phoneNumber, email }) => {
    return (
        <div className="main-list__card">
            <div className="main-list__card-image">
                <i className="fa-light fa-user"></i>
                <div className="main-list__card-image-initials">
                    {avatar && avatar.trim() !== "" ? (
                            <img src={avatar} alt="Profile Image" />
                        ) : (
                                <div className="main-content__timeline-user-initials">
                                    <span>{initials}</span>
                                </div>
                        )}
                </div>
            </div>
            <div className="main-list__card-name">{firstName} {lastName}</div>
            <div className="main-list__card-role">{roleName}{phoneNumber}</div>
            <div className="main-list__card-location">{addressStreet} {addressNumber} {email}</div>
            <div className="main-list__card-actions">
                <button onClick={onEditClick}>
                    <i className="fa-regular fa-pen-to-square"></i>
                    <span>Edit</span>
                </button>
                <button onClick={onDeleteClick}>
                    <i className="fa-regular fa-trash-can"></i>
                    <span>Delete</span>
                </button>
            </div>
        </div>
    );
};

export default Card;
